<template>
    <div v-if="qty > 0" :id="'catalog_item_' + this.localProduct_id" class="card4__tag card4__tag--green">
            <span class="card4__tag-text"> <span :id="'catalog_item_qty_'+ this.localProduct_id">{{ qty}}</span> шт. в корзине</span>
    </div>
</template>

<script>
    export default {
        name: "product-qty-in-cart",
        props: {
            product_id: {
                type: Number
            },
        },
        data() {
            return {
                localProduct_id: this.product_id,
            }
        },
        computed: {
            qty() {
                return this.$store.getters.cartproduct(this.localProduct_id)
            }
        }
    }
</script>

<style scoped>

</style>